import { api } from "./apiService";

const GetLeavePolicyList = async () => {
    return api.get("/LeavePolicy/GetLeavePolicyList");
};

// INSERT
const PostLeavePolicy = async ({
    empType,
    leaveTypeId,
    annualAllocate,
    monthlyEarn,
    quarter1,
    quarter2,
    quarter3,
    quarter4,
    prorata,
    carry,
    maxCarry,
    isActive,
    calculationMethod,
    userId,
    p_effectiveStartDate,
    p_effectiveEndDate,
}) => {
    const params = new URLSearchParams({
        p_empType: String(empType),
        p_leaveTypeId: String(leaveTypeId),
        p_anAllocate: String(annualAllocate),
        p_mothlyEarns: String(monthlyEarn),
        p_quarter1: String(quarter1 ?? 0),
        p_quarter2: String(quarter2 ?? 0),
        p_quarter3: String(quarter3 ?? 0),
        p_quarter4: String(quarter4 ?? 0),
        p_prorata: prorata,
        p_carry: carry,
        p_maxcarry: String(maxCarry),
        p_isActive: isActive,
        p_CalMethod: calculationMethod,
        p_userId: userId,
    });

    if (p_effectiveStartDate) {
        params.append('p_effectiveStartDate', p_effectiveStartDate);
    }
    if (p_effectiveEndDate) {
        params.append('p_effectiveEndDate', p_effectiveEndDate);
    }

    return api.post(`/LeavePolicy/PostLeavePolicy?${params.toString()}`);
};


// UPDATE
const UpdateLeavePolicy = async ({
    policyId,
    empType,
    leaveTypeId,
    annualAllocate,
    monthlyEarn,
    quarter1,
    quarter2,
    quarter3,
    quarter4,
    prorata,
    carry,
    maxCarry,
    isActive,
    calculationMethod,
    p_effectiveStartDate,
    p_effectiveEndDate,
    // userId removed
}) => {
    const safeNum = (v, fallback = 0) => {
        if (v === null || v === undefined || v === '') return String(fallback);
        const n = Number(v);
        return String(Number.isFinite(n) ? n : fallback);
    };

    const params = new URLSearchParams({
        p_policyId:    safeNum(policyId),
        p_empType:     safeNum(empType),
        p_leaveTypeId: safeNum(leaveTypeId),
        p_anAllocate:  safeNum(annualAllocate),
        p_mothlyEarns: safeNum(monthlyEarn),
        p_quarter1:    safeNum(quarter1),
        p_quarter2:    safeNum(quarter2),
        p_quarter3:    safeNum(quarter3),
        p_quarter4:    safeNum(quarter4),
        p_prorata:     prorata || 'N',
        p_carry:       carry || 'N',
        p_maxcarry:    safeNum(maxCarry),
        p_isActive:    isActive || 'A',
        p_CalMethod:   calculationMethod || 'ANNUAL_ALLOCATION',
        // p_userId removed — backend reads it from the auth token
    });

    if (p_effectiveStartDate) params.append('p_effectiveStartDate', p_effectiveStartDate);
    if (p_effectiveEndDate)   params.append('p_effectiveEndDate',   p_effectiveEndDate);

    return api.post(`/LeavePolicy/PostLeavePolicy?${params.toString()}`);
};

const policyService = {
    GetLeavePolicyList,
    PostLeavePolicy,
    UpdateLeavePolicy,
};

export default policyService;